export const DownloadIcon = ({ color }) => {
	const style2 = {
		fill: color,
		strokeMiterLimit: 10,
		strokeWidth: "17px",
	};

	return (
		<svg
			style={{ height: "123%", marginLeft: "9%" }}
			id="Layer_1"
			data-name="Layer 1"
			xmlns="http://www.w3.org/2000/svg"
			viewBox="0 0 558.17 558.17"
		>
			<defs>
				<clipPath id="clippath">
					<rect
						className="cls-3"
						x=".03"
						y=".06"
						width="558.14"
						height="558.12"
					/>
				</clipPath>
			</defs>
			<path
				style={style2}
				d="m275.65,356.86c1.53,1.53,3.36,2.74,5.38,3.58,2.02.84,4.16,1.28,6.31,1.28s4.3-.44,6.31-1.28c2.03-.84,3.86-2.05,5.38-3.58l66.09-66.09c6.46-6.46,6.46-16.91,0-23.37-6.46-6.45-16.91-6.45-23.37,0l-37.89,37.89v-158.4c0-9.13-7.4-16.52-16.52-16.52s-16.52,7.39-16.52,16.52v158.4l-37.89-37.89c-6.45-6.45-16.91-6.45-23.37,0-6.45,6.45-6.45,16.91,0,23.37l66.09,66.09h0Zm160.42,4.85v49.57c0,9.13-7.4,16.52-16.52,16.52H138.63c-9.13,0-16.52-7.4-16.52-16.52v-49.57c0-9.13,7.4-16.52,16.52-16.52s16.52,7.39,16.52,16.52v33.05h247.87v-33.05c0-9.13,7.4-16.52,16.52-16.52s16.52,7.39,16.52,16.52h0Z"
			/>
		</svg>
	);
};
